import type { ChainNode, ChainEdge, Company, FinancialRecord, Ranking } from '../types';

const DATA_BASE = '/data';

export async function loadNodes(): Promise<ChainNode[]> {
  const res = await fetch(`${DATA_BASE}/nodes.json`);
  return res.json();
}

export async function loadEdges(): Promise<ChainEdge[]> {
  const res = await fetch(`${DATA_BASE}/edges.json`);
  return res.json();
}

export async function loadCompanies(): Promise<Company[]> {
  const res = await fetch(`${DATA_BASE}/companies.json`);
  return res.json();
}

export async function loadFinancials(): Promise<FinancialRecord[]> {
  const res = await fetch(`${DATA_BASE}/financials.json`);
  return res.json();
}

export async function loadRankings(): Promise<Ranking[]> {
  const res = await fetch(`${DATA_BASE}/rankings.json`);
  return res.json();
}

// 预计算索引（由 build_json.py 生成）
export interface NodeInvestData {
  avgIps: number;
  attractiveness: 'high' | 'medium' | 'low';
  hasInvestable: boolean;
  companyCount: number;
  topCompanies: Array<{ id: string; name: string; ips: number }>;
}

export interface ChainIndex {
  upstreamMap: Record<string, string[]>;
  downstreamMap: Record<string, string[]>;
  nodeCompaniesMap: Record<string, string[]>;
  companyNodesMap: Record<string, string[]>;
  nodeInvestMap: Record<string, NodeInvestData>;
  pathIndex: Record<string, { path: string[]; focusIndex: number }>;
}

export async function loadIndex(): Promise<ChainIndex> {
  const res = await fetch(`${DATA_BASE}/index.json`);
  const arr = await res.json();
  // index.json 存为单元素数组（write_json 兼容），取第一个
  return Array.isArray(arr) ? arr[0] : arr;
}
